var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissionTrustS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 245,
    viewBox: "0 0 350 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_6969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_187_6969)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_187_6969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.727 -0.0196613L120.301 55.506L175.727 111.032L231.153 55.506L175.727 -0.0196613Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.727 -0.0196613L120.301 55.506L175.727 111.032L231.153 55.506L175.727 -0.0196613Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.747 42.2865C178.7 42.2865 181.587 41.4092 184.042 39.7656C186.497 38.122 188.411 35.7858 189.542 33.0526C190.672 30.3193 190.967 27.3118 190.391 24.4103C189.815 21.5087 188.393 18.8434 186.305 16.7515C184.217 14.6596 181.556 13.2345 178.66 12.6573C175.763 12.0801 172.761 12.3768 170.033 13.5089C167.305 14.6411 164.973 16.5579 163.332 19.0178C161.691 21.4776 160.816 24.3699 160.816 27.3284C160.816 29.2927 161.202 31.2378 161.952 33.0526C162.702 34.8674 163.802 36.5162 165.189 37.9052C166.575 39.2942 168.222 40.3961 170.033 41.1478C171.845 41.8995 173.786 42.2865 175.747 42.2865Z",
    stroke: "#6A7C89",
    strokeWidth: 0.248913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4271 146.772C74.3811 146.772 77.2686 145.894 79.7244 144.249C82.1803 142.605 84.0941 140.268 85.2236 137.533C86.3532 134.799 86.6476 131.79 86.0698 128.888C85.4921 125.986 84.0681 123.321 81.9779 121.23C79.8878 119.139 77.2255 117.715 74.3279 117.141C71.4302 116.566 68.4274 116.865 65.6994 118C62.9715 119.135 60.6408 121.056 59.0026 123.518C57.3643 125.98 56.4919 128.874 56.4959 131.833C56.5011 135.797 58.0765 139.597 60.876 142.398C63.6756 145.199 67.4706 146.772 71.4271 146.772Z",
    stroke: "#6A7C89",
    strokeWidth: 0.248913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.047 146.772C283.001 146.772 285.889 145.894 288.345 144.249C290.801 142.605 292.714 140.268 293.844 137.533C294.974 134.799 295.268 131.79 294.69 128.888C294.112 125.986 292.688 123.321 290.598 121.23C288.508 119.139 285.846 117.715 282.948 117.141C280.051 116.566 277.048 116.865 274.32 118C271.592 119.135 269.261 121.056 267.623 123.518C265.985 125.98 265.112 128.874 265.116 131.833C265.121 135.797 266.697 139.597 269.496 142.398C272.296 145.199 276.091 146.772 280.047 146.772Z",
    stroke: "#6A7C89",
    strokeWidth: 0.248913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.727 45.7622L89.8193 131.825L175.727 217.887L261.635 131.825L175.727 45.7622Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.741 89.0477L133.06 131.805L175.74 174.562L218.421 131.805L175.741 89.0477Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.055 131.816H80.1877",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.727 65.961L109.981 131.825L175.727 197.689L241.472 131.825L175.727 65.961Z",
    stroke: "#6A7C89",
    strokeWidth: 0.248913,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.22 6.97 6.22 6.97 6.22 6.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4268 140.118C72.548 140.173 73.6687 139.999 74.7209 139.607C75.773 139.215 76.7348 138.613 77.5478 137.838C78.3607 137.062 79.0078 136.129 79.4501 135.096C79.8923 134.062 80.1203 132.949 80.1203 131.824C80.1203 130.7 79.8923 129.587 79.4501 128.553C79.0078 127.52 78.3607 126.587 77.5478 125.811C76.7348 125.036 75.773 124.434 74.7209 124.042C73.6687 123.65 72.548 123.476 71.4268 123.531",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.427 136.423C73.9677 136.423 76.0273 134.36 76.0273 131.815C76.0273 129.269 73.9677 127.206 71.427 127.206C68.8863 127.206 66.8267 129.269 66.8267 131.815C66.8267 134.36 68.8863 136.423 71.427 136.423Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.419 131.816H271.759",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.047 123.532C277.922 123.636 275.918 124.555 274.45 126.099C272.982 127.643 272.164 129.694 272.164 131.825C272.164 133.957 272.982 136.008 274.45 137.552C275.918 139.096 277.922 140.015 280.047 140.119",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.047 136.423C282.588 136.423 284.648 134.36 284.648 131.815C284.648 129.269 282.588 127.206 280.047 127.206C277.507 127.206 275.447 129.269 275.447 131.815C275.447 134.36 277.507 136.423 280.047 136.423Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.727 89.0662V35.6104",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.458 27.3282C167.563 29.4576 168.48 31.4654 170.021 32.9356C171.562 34.4057 173.609 35.2256 175.737 35.2256C177.865 35.2256 179.912 34.4057 181.453 32.9356C182.994 31.4654 183.912 29.4576 184.016 27.3282",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.747 31.935C176.656 31.9311 177.543 31.6577 178.297 31.1489C179.051 30.6401 179.638 29.919 179.983 29.0766C180.328 28.2341 180.416 27.3082 180.237 26.4155C180.057 25.5228 179.617 24.7035 178.973 24.0609C178.329 23.4184 177.509 22.9816 176.617 22.8053C175.726 22.6291 174.802 22.7212 173.962 23.0706C173.123 23.42 172.405 24.0111 171.901 24.7685C171.396 25.526 171.127 26.4161 171.127 27.3268C171.127 27.9337 171.246 28.5346 171.479 29.095C171.711 29.6554 172.052 30.1644 172.481 30.5926C172.911 31.0208 173.42 31.3598 173.98 31.5902C174.541 31.8206 175.141 31.9376 175.747 31.935Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.417 96.0998L160.796 86.7038L147.987 83.2474L151.417 96.0998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.417 96.0998L160.796 86.7038L147.987 83.2474L151.417 96.0998Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.037 96.0998L190.658 86.7038L203.487 83.2474L200.037 96.0998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.037 96.0998L190.658 86.7038L203.487 83.2474L200.037 96.0998Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.356 159.427L146.995 178.1L153.817 152.574L128.356 159.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.356 159.427L146.995 178.1L153.817 152.574L128.356 159.427Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.046 165.307L153.816 152.574",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.118 159.427L204.459 178.1L197.638 152.574L223.118 159.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.118 159.427L204.459 178.1L197.638 152.574L223.118 159.427Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.428 165.307L197.638 152.574",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.727 227.008C180.765 227.008 184.849 222.917 184.849 217.87C184.849 212.824 180.765 208.733 175.727 208.733C170.69 208.733 166.606 212.824 166.606 217.87C166.606 222.917 170.69 227.008 175.727 227.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.727 227.008C180.765 227.008 184.849 222.917 184.849 217.87C184.849 212.824 180.765 208.733 175.727 208.733C170.69 208.733 166.606 212.824 166.606 217.87C166.606 222.917 170.69 227.008 175.727 227.008Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.727 224.326C179.286 224.326 182.171 221.436 182.171 217.87C182.171 214.305 179.286 211.414 175.727 211.414C172.168 211.414 169.282 214.305 169.282 217.87C169.282 221.436 172.168 224.326 175.727 224.326Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.727 174.564V208.751",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.606 172.279L134.344 190.852L141.046 165.306L115.606 172.279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.606 172.279L134.344 190.852L141.046 165.306L115.606 172.279Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.26 174.208L132.322 183.206L135.574 170.831L123.26 174.208Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.388 190.773L235.928 172.001L210.428 165.306L217.388 190.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.388 190.773L235.928 172.001L210.428 165.306L217.388 190.773Z",
    stroke: "#6A7C89",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.311 183.125L228.293 174.027L215.94 170.77L219.311 183.125Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeWidth: 0.497826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.418 131.828L175.737 89.0706L133.057 131.828L175.737 174.585L218.418 131.828Z",
    fill: "url(#paint0_linear_187_6969)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.769 138.832H167.117V136.516H164.967V121.59H177.482C180.87 121.59 183.238 123.437 184.573 126.006C185.315 127.472 185.756 129.066 185.872 130.697C186.008 132.362 185.833 134.038 185.356 135.641C184.428 138.667 182.326 141.144 179.1 141.696C177.853 141.845 176.595 141.889 175.341 141.826C174.667 141.802 173.969 141.802 173.635 141.802H173.635V144.13H175.304C176.706 144.203 178.111 144.15 179.503 143.973C183.758 143.252 186.465 140.112 187.634 136.295C188.206 134.422 188.422 132.462 188.272 130.512C188.131 128.574 187.605 126.68 186.723 124.938C185.001 121.614 181.943 119.25 177.507 119.25H162.583V138.832H163.769ZM176.89 124.611H168.42L168.408 126.954H168.42V136.503H168.408V138.823L168.42 138.824V141.821L162.713 141.79L162.721 144.11L169.614 144.134L170.804 144.122V138.83C173.355 138.835 175.778 138.831 176.318 138.804H176.439L176.448 138.803C178.098 138.728 182.682 138.519 182.682 131.835C182.666 125.005 176.91 124.611 176.89 124.611ZM170.804 136.503H176.197H176.322C177.37 136.456 180.311 136.322 180.302 131.855C180.302 127.494 177.177 127.002 176.757 126.954H170.804V136.503Z",
    fill: "#0A1214"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_187_6969",
    x: 120.052,
    y: -2.2601,
    width: 111.349,
    height: 113.541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.9913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.22283
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.470588 0 0 0 0 0.882353 0 0 0 0 0.984314 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_187_6969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_6969",
    x1: 175.738,
    y1: 88.9319,
    x2: 176.123,
    y2: 174.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467477,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_6969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 245,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_187_6969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239.454,
    height: 229,
    fill: "white",
    transform: "translate(56 -1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionTrustS);
export default __webpack_public_path__ + "static/media/missionTrustS.fbff98ffd7e858440152e122c03a0085.svg";
export { ForwardRef as ReactComponent };